import React from 'react'
import PropTypes from 'prop-types'
import '../../index.css'

const ApprovalSelect = ({ isActive = false, width, height }) => {
    return (
        <>

            <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} viewBox="0 0 36 36" fill="none">
                {isActive
                    ? <>
                        <path fillRule="evenodd" clipRule="evenodd" d="M0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12ZM11.3152 17.136L18.224 8.4992L16.976 7.5008L11.0848 14.8624L6.912 11.3856L5.888 12.6144L11.3152 17.136Z" fill="white"/>
                    </>
                    : <>
                        <g clipPath="url(#clip0_15988_33884)">
                            <path d="M6.39688 12.0008L11.1969 16.0008L17.5969 8.00078M11.9969 23.2008C10.5261 23.2008 9.06967 22.9111 7.71082 22.3482C6.35197 21.7854 5.1173 20.9604 4.07728 19.9204C3.03726 18.8804 2.21228 17.6457 1.64942 16.2868C1.08657 14.928 0.796875 13.4716 0.796875 12.0008C0.796875 10.53 1.08657 9.07357 1.64942 7.71473C2.21228 6.35588 3.03726 5.1212 4.07728 4.08119C5.1173 3.04117 6.35197 2.21618 7.71082 1.65333C9.06967 1.09048 10.5261 0.800781 11.9969 0.800781C14.9673 0.800781 17.8161 1.98078 19.9165 4.08119C22.0169 6.18159 23.1969 9.03036 23.1969 12.0008C23.1969 14.9712 22.0169 17.82 19.9165 19.9204C17.8161 22.0208 14.9673 23.2008 11.9969 23.2008Z" stroke="#007876"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_15988_33884">
                                <rect width="24" height="24" fill="white"/>
                            </clipPath>
                        </defs>                    </> }
            </svg>
        </>
    )
}

ApprovalSelect.propTypes = {
    isActive: PropTypes.bool,
    width: PropTypes.any,
    height: PropTypes.any
}

export default ApprovalSelect
